const AccountStatus = {
    New: 1,
    Queried: 2,
    Processed: 3,
    Accepted: 4,
    Rejected: 5,
    //Administered: 6,
    PartlyAccepted: 7,
    Verified: 8,
    Administration: 9,
};

export default AccountStatus;
